import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import shellMuiTheme from 'components/AppShell/muiTheme';

const POPUP_MESSAGE_TYPE = 'BITRIX_AUTH_SUCCESS';

export default function BitrixSuccessPage() {
  const navigate = useNavigate();
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (window.opener && !window.opener.closed) {
      setClosing(true);
      // Даём пользователю секунду увидеть успех, потом уведомляем родителя
      const timer = setTimeout(() => {
        window.opener.postMessage({ type: POPUP_MESSAGE_TYPE }, window.location.origin);
        window.close();
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      // Fallback: та же вкладка — возвращаемся на оценки
      const timer = setTimeout(() => navigate('/estimation'), 2000);
      return () => clearTimeout(timer);
    }
  }, [navigate]);

  return (
    <ThemeProvider theme={shellMuiTheme}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          gap: 3,
          px: 3,
          fontFamily:
            "'Inter', 'IBM Plex Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            width: '100%',
            maxWidth: 360,
            textAlign: 'center',
          }}
        >
          {/* Иконка успеха с анимацией */}
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: 3,
              background: (t) =>
                `linear-gradient(135deg, ${t.palette.success.main} 0%, ${t.palette.success.dark} 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: (t) => `0 8px 24px ${t.palette.success.main}40`,
              animation: 'pop 0.3s ease-out',
              '@keyframes pop': {
                '0%': { transform: 'scale(0.6)', opacity: 0 },
                '100%': { transform: 'scale(1)', opacity: 1 },
              },
            }}
          >
            <CheckCircleOutlineRoundedIcon sx={{ color: '#fff', fontSize: 36 }} />
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
              Авторизация прошла успешно
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {closing ? 'Окно закрывается…' : 'Возвращаемся обратно…'}
            </Typography>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
